import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.creditPack.name.label,
  validators: []
}

let available = {
  fieldKey: "available",
  type: "switch",
  label: strings.form.creditPack.available.label,
  validators: []
}

export const form = {
  formKey: "creditPack",
  fields: [
    name,
    available
  ]
}
